import { library } from "@fortawesome/fontawesome-svg-core";
import { faProjectDiagram } from "@fortawesome/pro-regular-svg-icons/faProjectDiagram";
import {
  GlobalCustomSVGStyles as OrcsGlobalCustomSVGStyles,
  setupFontAwesome as setupOrcsFontAwesome,
} from "orcs-design-system";

export const GlobalCustomSVGStyles = OrcsGlobalCustomSVGStyles;

const setupFontAwesome = () => {
  setupOrcsFontAwesome();
  library.add(faProjectDiagram);
};

export default setupFontAwesome;
